import {useUpmPlant} from '@hconnect/upm'
import {useForm} from 'react-hook-form'

import {useKilns, useRefraModal} from '@refra/modules/common/providers'
import {useEditStaticPart} from '@refra/modules/refra-static-parts/hooks/mutations'
import {EditStaticPartDTO, StaticPartDTO} from '@refra/modules/refra-static-parts/types'
import {useUrlParam} from '@refra/modules/routing/hooks'

interface UseEditStaticPartFormProps {
  staticPart: StaticPartDTO
}

export const useEditStaticPartForm = ({staticPart}: UseEditStaticPartFormProps) => {
  const plantId = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId})
  const {selectedKiln} = useKilns()
  const {closeModal} = useRefraModal()

  const {mutate: editStaticPart, isPending: isEditingStaticPart} = useEditStaticPart({})

  const formMethods = useForm<EditStaticPartDTO>({
    defaultValues: {
      name: staticPart.name,
      description: staticPart.description
    }
  })

  const onSubmit = formMethods.handleSubmit((values: EditStaticPartDTO) => {
    editStaticPart(
      {
        plantUpmId: upmPlant.upmId,
        kilnUpmId: selectedKiln.upmId,
        staticPartId: staticPart.id,
        staticPartDTO: {
          name: values.name,
          description: values.description
        }
      },
      {onSuccess: () => onClose()}
    )
  })

  const onClose = () => {
    formMethods.reset()
    closeModal()
  }

  return {formMethods, isFormBeingProcessed: isEditingStaticPart, onSubmit, onClose}
}
